import { FC } from 'react';

import Camera, { CameraProps } from './Backstage.Camera';
import Microphone, { MicrophoneProps } from './Backstage.Microphone';
import Provider, { BackstageProviderProps } from './Backstage.Provider';

export type BackstageProps = BackstageProviderProps & {};

export type BackstageComposition = {
  Microphone: FC<MicrophoneProps>;
  Camera: FC<CameraProps>;
};

const Backstage: FC<BackstageProps> & BackstageComposition = ({ children, ...props }): JSX.Element => (
  <Provider {...props}>{children}</Provider>
);

Backstage.Camera = Camera;
Backstage.Microphone = Microphone;

export default Backstage;
